import styled from 'styled-components';

import { Tabs } from '@/shared/uikitV2/antd/Tabs';

export const Container = styled.div`
  z-index: 10000;
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.95);

  font-size: 14px;
`;

export const Header = styled.div`
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  height: 40px;
  padding: 0 8px 0 48px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background: rgba(255, 255, 255, 0.95);
`;

export const TabsStyled = styled(Tabs)`
  &&& .ant-tabs-tab {
    margin-left: 4px;
    padding: 8px;
  }
`;

export const TabContainer = styled.div`
  padding-top: calc(40px + 16px);
  padding-bottom: 40px;
  padding-inline: 16px;
  height: 100dvh;
  overflow-x: hidden;

  @media screen and (max-width: 1000px) {
    padding-top: calc(40px + 6px);
    padding-inline: 6px;
  }
`;
